class UnitOfMeasure extends HTMLElement {
  constructor() {
    super();
    this.unitPrice = this.querySelector('.js-product-unit');
    this.unitPriceProduct = this.querySelector('.js-product-unit-product');
    this.unitPriceHolder = this.querySelector('.js-product-unit-holder');
    this.init(this);
  }

  init(self) {
    if(window.productUnitApi != '') {
      if(self.unitPrice) {
        let ids = [];
        ids.push(self.unitPrice.getAttribute('data-product-id'))
        let dataIds = ids.join();
        let  url =  window.productUnitApi + 'api/pricingProduct/getProductType/' + dataIds;
        fetch(url, {
          method: "GET",
          data: '',
          dataType: 'json'
        })
          .then(response => {
            return response.json();
          }).then(data => {
          for(let i = 0; i < data.length; i++) {
            for(let j=0; j < data[i].variants.length; j++) {
              
              let unitEl = self.querySelector(`.js-product-unit[data-product-id="${data[i].id}"][data-variant-id="${data[i].variants[j].variantId}"]`);
              if(unitEl) {
                let typeGet = self.getAttribute('data-type-get');
                let sortedPrices = data[i].variants.sort(function(a, b) {
                  return parseFloat(a.price) < parseFloat(b.price) ? -1 : 1
                });
                if(unitEl.getAttribute('data-available-variants-ids') !== '') {
                  let availableVariantsIds = unitEl.getAttribute('data-available-variants-ids').substring(1).split(',');
                  if(availableVariantsIds.length >0) {
                    let newSortedPrices = [];
                    sortedPrices.forEach(element => {
                      if (availableVariantsIds.includes(element.variantId)) {
                        newSortedPrices.push(element);
                      }
                      if (newSortedPrices.length > 0) {
                        sortedPrices = newSortedPrices;
                      }
                    });
                  }
                }
                let valuePrices = sortedPrices[0];
                if (typeGet === 'by-variation') {
                  let variationSelect = self.getAttribute('data-variation-select');
                  sortedPrices.forEach(item => {
                    if(item.variantId == variationSelect) {
                      valuePrices = item;
                    }
                  })
                }
                let currency = valuePrices.value;
                if(currency == 'unit') {
                  currency = 'u';
                }
                if (typeGet === 'by-variation') {
                  unitEl.innerHTML = valuePrices.price + '€/' + currency;
                } else {
                  unitEl.innerHTML = window.price_per.replace('{{ value }}',  valuePrices.price + '€/' + currency);
                }
              }
            }
          }
        }).catch(error => {
          console.log('Error Fetch')
        })
      } else {
        if (self.unitPriceHolder) {
          self.unitPriceHolder.classList.add('is-show')
        }
      }

      if(self.unitPriceProduct) {
        let unitPriceProduct = self.unitPriceProduct;
        let ids = unitPriceProduct.getAttribute('data-product-id');
        let url = window.productUnitApi + 'api/pricingProduct/getSingleProduct/' + ids;
        fetch(url, {
          method: "GET",
          data: '',
          dataType: 'json'
        }).then(response => {
          return response.json();
        }).then(data => {
          window.variatsUnits = data;
          for(let i=0; i< data.length; i++) {
            for(let j =0; j< data[i].variants.length; j++) {
              let unitEl = document.querySelectorAll(`.js-product-unit-product[data-product-id="${data[i].id}"][data-variant-id="${data[i].variants[j].variantId}"]`);
              let currency = data[i].variants[j].value;
              if(currency == 'unit') {
                currency = 'u';
              }
              if (unitEl.length > 0) {
                unitEl.forEach(item => {
                  item.innerHTML = data[i].variants[j].price + '€/' + currency
                })
              }
            }
          }
        })
      } else {
        if (self.unitPriceHolder) {
          self.unitPriceHolder.classList.add('is-show')
        }
      }
    } else {
      if (self.unitPriceHolder) {
        self.unitPriceHolder.classList.add('is-show')
      }
    }
  }
}
customElements.define('unit-of-measure', UnitOfMeasure)

